// Shared HTML-escape helper used across every browser surface (main app, admin,
// library, store) and the server. Unlike the older `div.textContent = s;
// return div.innerHTML` pattern, this escapes `"` and `'` as well as `< > &`, so
// values interpolated into double-quoted HTML attributes cannot break out of the
// attribute (attribute-injection XSS). Pure and DOM-free so it runs identically
// in Node and the browser.

const HTML_ESCAPES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

export function escapeHtml(s) {
  return String(s ?? '').replace(/[&<>"']/g, (c) => HTML_ESCAPES[c]);
}

export { escapeHtml as esc };
